<script lang="ts" setup>
import type { IProps } from './ArticleCard.types'

defineProps<IProps>()
</script>

<template>
  <article class="card">
    <NuxtLink :to="url">
      <img
        class="card__image"
        :src="image"
        :alt="title"
        loading="lazy"
      >
    </NuxtLink>
    <div class="card__content">
      <h5 class="card__title">
        <NuxtLink :to="url">
          {{ title }}
        </NuxtLink>
      </h5>
      <p class="card__description">
        {{ description }}
      </p>
      <div class="card__meta">
        <time
          v-if="date"
          :datetime="date"
          class="card__date"
        >
          {{ date }}
        </time>
        <span
          v-if="author"
          class="card__author"
        >
          {{ author }}
        </span>
      </div>
    </div>
  </article>
</template>

<style lang="scss" scoped>
.card {
  max-width: 41rem;
  font-weight: 500;
  background-color: $white;
  border-radius: 1.2rem;

  &__image {
    width: 100%;
    height: 24.8rem;
    object-fit: cover;
    object-position: center;
    border-radius: 1.2rem;

    @include atM {
      height: 33rem;
    }

    @include atL {
      height: 38rem;
    }

    @include atXL {
      height: 41rem;
    }
  }

  &__content {
    padding: 1.6rem 1.6rem 2.4rem 1.6rem;

    @include atM {
      padding: 2.4rem 3.2rem 3rem 3.2rem;
    }
  }

  &__title {
    margin-bottom: 0.8rem;
    font-size: 1.8rem;
    line-height: 2.4rem;

    @include atM {
      font-size: 2rem;
      line-height: 2.8rem;
    }
  }

  &__description {
    display: -webkit-box;
    overflow: hidden;
    color: $text-300;
    font-size: 1.6rem;
    line-height: 2.4rem;
    white-space: normal;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 3;
  }

  &__meta {
    margin-top: 1.6rem;
  }

  &__date,
  &__author {
    display: inline-block;
    font-weight: 500;
    font-size: 1.6rem;
    line-height: 2.4rem;
  }

  &__date {
    padding-right: 1.6rem;
    color: $text-200;
  }

  &__author {
    padding-left: 1.6rem;
    color: $text-300;
    border-left: 0.1rem solid $gray-300;
  }
}
</style>
